export function hasKey<T extends Record<PropertyKey, unknown>>(thing: T, key: string): key is keyof T & string {
	if (Array.isArray(thing)) {
		return thing.includes(key);
	}
	if (typeof thing === 'object') {
		return key in thing;
	}
	return false;
}
